import React from "react";
import { QuickStatsCard } from "@shared/components/QuickStatsCard";
import { Droplet, TrendingDown, TrendingUp, Info } from "lucide-react";
import { useTranslation } from "react-i18next";

export const ConsumptionKpiCards = () => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <QuickStatsCard
        title={t("Current Month")}
        displayValue="9.2 CCF"
        trendSummary={t("6,881.6 gal")}
        icon={
          <div className="bg-blue-50 w-10 h-10 rounded-full flex items-center justify-center">
            <Droplet className="w-5 h-5 text-blue-600" />
          </div>
        }
        className="shadow-sm border-slate-100 bg-white rounded-xl"
      />
      <QuickStatsCard
        title={t("6-Month Average")}
        displayValue="10.1 CCF"
        trendSummary={t("Your baseline")}
        icon={
          <div className="bg-teal-50 w-10 h-10 rounded-full flex items-center justify-center">
            <TrendingDown className="w-5 h-5 text-teal-600" />
          </div>
        }
        className="shadow-sm border-slate-100 bg-white rounded-xl"
      />
      <QuickStatsCard
        title={t("Peak Month")}
        displayValue="14.8 CCF"
        trendSummary={t("July 2024")}
        icon={
          <div className="bg-orange-50 w-10 h-10 rounded-full flex items-center justify-center">
            <TrendingUp className="w-5 h-5 text-orange-600" />
          </div>
        }
        className="shadow-sm border-slate-100 bg-white rounded-xl"
      />
      <QuickStatsCard
        title={t("vs Avg Household")}
        displayValue="-1.7 CCF"
        trendSummary={t("Below avg ✓")}
        icon={
          <div className="bg-green-50 w-10 h-10 rounded-full flex items-center justify-center">
            <Info className="w-5 h-5 text-green-600" />
          </div>
        }
        className="shadow-sm border-slate-100 bg-white rounded-xl"
      />
    </div>
  );
};
